import * as types from './mutation-types';

export default {
  [types.SET_SUPPLIER_COLLECTION](state, payload) {
    state.supplierCollection = payload;
  },
  [types.SET_CLIENT_COLLECTION](state, payload) {
    state.clientCollection = payload;
  },
  [types.SET_SHIPPING_COMPANY_COLLECTION](state, payload) {
    state.shippingCompanyCollection = payload;
  },
  [types.SET_VEHICLE_COLLECTION](state, payload) {
    state.vehicleCollection = payload;
  },
  [types.SET_ADDRESS_COLLECTION](state, payload) {
    state.addressCollection = payload;
  },
  [types.SET_UF_COLLECTION](state, payload) {
    state.ufCollection = payload;
  },
};
